import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/zh2';
export const locale = {
  lang: 'zh2',
  data: {
    'RAWDATA': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
      },
      'TITULO': '咨询原始数据',
      'SUBTITULO': '查阅特定时期平台生成的调查原始数据信息',
      'NOFILE': '未生成',
      'FILTER': '按公司或调查令牌过滤',
      'DOWNLOADFILE': '下载文件',
      'CAMPOS': {
        'anio': '年',
        'broker': '经纪人',
        'brokerCountry': '经纪国',
        'anioRanking': '年度排名',
      },
      'COLUMNAS': {
        'nombre': '公司',
        'producto': '产品类别',
        'surveytoken': '调查令牌',
        'fecha': '日期',
        'acciones': '原始数据',
      },
      'RESULTADOS': {
        'CARGANDO': '加载搜索结果',
        'TITULO': '结果',
        'ENCONTRADAS': '发现的调查总数',
        'DESCARGAR': '下载Excel格式的资料',
        'SINRESULTADOS': '找不到使用指定参数创建的调查'
      }
    }
  }
};
